<template>
  <div>
    <header-bar>
      スプリット
    </header-bar>
    <div class="page-block page-block-feature">
      <div class="page-block__inner">
        <div class="my-release-search-wrap">
          <b>内容確認</b> <br />
          <p>あなたのスプリット情報</p>
          <div
            class="info-container">
            <span class="form-title">
              この作品の管理者は{{ owner }}です。
            </span>
            <p>リリースタイトル：{{ releaseTitle }}</p>
            <div
              v-for="revenueShareData in revenueShareDataArray "
              :key="revenueShareData.id"
              class="approve-content">
              <div>
                <p>作品名：{{ revenueShareData.product_disc_tracks.titles[0].title }}</p>
                <p>分配率：{{ revenueShareData.rate }}%</p>
                <p>役割：{{ revenueShareData.role.role }}</p>
              </div>
            </div>
          </div>
          <div class="c-btn-wrap">
            <button
              class="c-btn"
              name="submit"
              type="button"
              @click.prevent="confirmShare">
              承認する<span class="c-btn__icon-arrow" />
            </button>
            <button
              class="c-btn c-btn--back c-btn--back-left"
              @click.prevent="cancelRevenueShare()">
              <span>キャンセル</span>
            </button>
          </div>
        </div>
        <span></span>
      </div>
    </div>
    <confirm-dialog
      name="deleteArtist"
      :is-shown="confirmDialog"
      title="スプリットをキャンセルしますか？"
      :is-hover-on-default-button="true"
      @closed="onCancelClick"
      @default-clicked="onDefaultClicked"
      @cancel-clicked="onCancelClick">
      <template #body>
        あなたがキャンセルした場合、<br>
        スプリットは開始されません。
      </template>
    </confirm-dialog>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'
import ConfirmDialog from '../../../components/ConfirmDialog'

export default {
  name: 'RevenueShareDetail',
  components: {
    HeaderBar,
    ConfirmDialog,
  },
  data() {
    return {
      revenueShareDataArray: [{
        rate: '',
        email: '',
        role: {
          id: '',
          role: '',
        },
        memo: '',
        product_disc_tracks: {
          product: { title: '' },
          titles: [{ title: '' }],
        },
      }],
      rId: '',
      pdtId: '',
      confirmDialog: false,
      owner: '',
      releaseTitle: '',
      processableRevenueShare: [],
    }
  },
  async mounted() {
    this.rId = this.$route.params?.rId
    const { revenueShareId } = JSON.parse(window.sessionStorage.getItem('split')) || {}
    // check whether current processing revenueShareId and rId of query params match or not.
    if (!revenueShareId || parseInt(revenueShareId, 10) !== parseInt(this.rId, 10)) {
      this.$router.push({ name: 'index' })
      return
    }
    await this.getRevenueShareById(this.rId)
  },
  methods: {
    async getRevenueShareById(id) {
      try {
        let data = {}
        const response = await window.axios.get(`/api/client/revenueShare/${id}`)
        data = response.data
        this.releaseTitle = data[0].product_disc_tracks.product.title
        this.revenueShareDataArray = data
        this.processableRevenueShare = this.revenueShareDataArray.map(rs => rs.id)
        if (data.length > 0) {
          this.pdtId = data[0].product_disc_track_id
          await this.getOwner()
        }
      } catch (err) {
        window.location.href = '/client'
      }
    },
    async getOwner() {
      const { data } = await window.axios.get(`/api/client/revenueShare/collaborator/getOwner/?product_disc_track_id=${this.pdtId}`)
      this.owner = data
    },
    cancelRevenueShare() {
      this.confirmDialog = true
    },
    async confirmShare() {
      const response = await window.axios.post('/api/client/revenueShare/approve', this.processableRevenueShare)
      if (response.status === 200) await this.$router.push({ path: '/client/revenue-share/approval-complete' })
    },
    async onDefaultClicked() {
      const response = await window.axios.post(`/api/client/revenueShare/deleteSelected/${this.pdtId}`, this.processableRevenueShare)
      if (response.status === 204) {
        this.confirmDialog = false
        await this.$router.push({ path: '/client/revenue-share/cancel' })
      }
    },
    onCancelClick() {
      this.confirmDialog = false
    },
  },

}
</script>

<style scoped>
.page-block-feature {
  text-align: center;
  padding: 30px 20px;
}

.info-title {
  font-size: 28px;
}

.info-sec {
  font-size: 14px;
  opacity: .8;
  text-align: left;
}

.my-release-search-wrap img {
  width: 10%;
}

.my-release-search-wrap .row[data-v-8a7f9050] {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.my-release-search-wrap {
  height: auto;
  display: block;
}

.my-release-search-wrap .form-group {
  flex-direction: column;
  margin: 0 8px;
  border-bottom: none;
}

.my-release-search-wrap .form-wrap {
  padding: 0 10px;
}

.my-release-search-wrap .form-group .form-label {
  width: 100px;
}

.my-release-search-wrap .row {
  display: flex;
  justify-content: space-between;
}

.form-title {
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
}

table {
  width: -webkit-fill-available;
  margin: 10px 0;
  border-collapse: separate;
  border-spacing: 10px;
  text-align: initial;
}

th, td {
  padding: 15px;
}

th {
  text-align: initial;
}
.info-container{
  text-align: start;
  margin: auto;
  width: fit-content;
  padding: 14px 0;
}

.approve-content {
  display: flex;
  margin-top: 5%;
  margin-bottom: 7%;
}

.checkbox {
  margin-right: 0;
}

</style>
